import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';

import * as actions from '../actions';
import * as c from '../constant';

function AddApprovalNotesModal({
  createTextArea,
  addApprovalNote,
  formData,
  id,
  updating,
  getItem,
  updateList,
  setFormData
}) {
  const setModal = useContext(ModalContext);
  const [charCount, setCharCount] = useState(0);

  const handleOnKeyUp = e => {
    e.preventDefault();
    setCharCount(() => formData.approval_notes.length);
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      approval_notes: formData.approval_notes,
    };

    addApprovalNote(id, args, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };

      setFormData(_.pick(args, _.keys(c.FORM_DATA_APPROVAL_NOTES)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createTextArea(
              { key: 'approval_notes', label: `Approval Note: ${charCount}/500` },
              { maxLength: '500', rows: '9', onKeyUp: handleOnKeyUp }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AddApprovalNotesModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  addApprovalNote: PropTypes.instanceOf(Function).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.ADD_APPROVAL_NOTE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddApprovalNotesModal);
